import React from 'react';
// const HomeProg2 = props => {
//   return (
//     <div>

//     </div>
//   )
// }
import { List, Form } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../components/funcionales/titder';

// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return ( 
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, handleClickidLista}) => {
  console.log(elemento.anchoImagen, elemento.ultInforme)

  let colorCelda='white'
  if(elemento.descrTarea && elemento.activo==='S'){
    if(elemento.tipoFrecuencia==='Calendario'){ 
      if(elemento.numCarta!=='' && elemento.numCarta!==null){
        if((elemento.enRuta==='N' || elemento.enRuta==='' || elemento.enRuta===null) && elemento.anchoImagen>=0){
          colorCelda = 'red'
        }else{
          if(elemento.enRuta==='S' && elemento.anchoImagen>=0){
            colorCelda = 'yellow'
          }else{
            colorCelda = 'green'
          }
        }
      }
    }else{
      if(elemento.ultInforme!=='' && elemento.ultInforme!==null){
        if((elemento.enRuta==='N' || elemento.enRuta==='' || elemento.enRuta===null) && elemento.ultInforme>=0){
          colorCelda = 'red'
        }else{
          if(elemento.enRuta==='S' && elemento.ultInforme>=0){
            colorCelda = 'yellow'
          }else{
            colorCelda = 'green'
          }
        }
      }
    }
  }
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProx?elemento.fechaProx.substr(0, 10):""}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.acumProx}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.acumulado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.activo?elemento.activo:""}</td>
    </tr>
  )
};
const ListaPl = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//FIN Lista de mecanismos

class HomeProg2 extends React.Component {

  render(){

  const a1505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "1505" );
console.log(this.props.list) 
  return (
    <div>
      <List selection>
        <TitDer list={this.props.list} textBoton1="Programación de lubricación" btnNuevo={"NO"} styles={this.props.styles}/>

        <div>
          <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '40%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaEmp styles={this.props.styles} list={this.props.list1}
                    handleChange={this.props.handleChange} /> 
                </Form.Field>
              </div>
              <div className="column" style={{width: '20%', paddingTop: '0em'}}>
                    <label style={{color: 'black', background: 'green', fontSize: '1.1em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      VIGENTE                  
                    </label>
                </div>
                <div className="column" style={{width: '20%', paddingTop: '0em'}}>
                    <label style={{color: 'black', background: 'yellow', fontSize: '1.1em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      PROGRAMADO                    
                    </label>
                </div>
                <div className="column" style={{width: '20%', paddingTop: '0em'}}>
                    <label style={{color: 'black', background: 'red', fontSize: '1.1em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      VENCIDO                    
                    </label>
                </div>
            </div>
          </div>
            <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Equipo</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Componente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Mecanismo</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Método</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Tarea</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Frecuencia</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Lubricante</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '4%'}}>Cant.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '3%'}}>Und</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Fec. prox.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Acum. prox.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Acum. actual</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Activo para LCM</th>
                </tr>
              </thead>
              <ListaPl list={this.props.list} handleClickidLista={a1505!==-1?this.props.handleClickidLista:()=>{}}/>
            </table>
            <p></p>
          </div>
      </List>
    </div>
  )
      }
};


export default HomeProg2